import { Window } from '@execonline-inc/browser-window.private';
import { emptyFragment, ListItem } from '@execonline-inc/execonline-ui';
import { just } from 'maybeasy';
import { observer } from 'mobx-react';
import { T } from '../../../Translations';
import navigationStore from './NavigationStore';

export interface Props {
  onClick?: () => void;
}

function SupportMenu({ onClick }: Props) {
  const handleClick = (href: string) => () => {
    if (onClick !== undefined) onClick();
    Window.openWindow(href, '_blank', { noopener: just(true), noreferrer: just(true) });
  };

  return navigationStore.supportMenuHref
    .map((href) => (
      <ListItem role="menuitem" onClick={handleClick(href)}>
        <T kind="Support" />
      </ListItem>
    ))
    .getOrElse(emptyFragment);
}

export default observer(SupportMenu);
